export function formateTestName(testName) {
	return testName.charAt(0).toUpperCase() + testName.slice(1).toLowerCase();
}
